import React from 'react';
import ReactDOM from 'react-dom';

import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

import reportWebVitals from './reportWebVitals';

import 'index.css';
import { store } from './store';
import App from './App';
import { ReportProvider } from './store/Reports';

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <ReportProvider>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </ReportProvider>
        </Provider>
    </React.StrictMode>,
    document.getElementById('rootApp')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
